<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="page-layout" v-if="vmodel !== null">
    <div class="container">
      <div class="grid mt-2 col-12">
        <span for="email-copy" class="heading-text">{{ lmodel.emailCopy }}</span>
      </div>
    </div>
    <div class="scroll-enable">
      <div class="container">
        <!-- Title start -->
        <div>
          <div class="grid mt-1 line-text">
            <div class="col-6 lg:col-6">
              <span for="saveemail-copy" class="heading-text">
                {{
                lmodel.ambSaveCodeSectionTitle
                }}
              </span>
            </div>
            <div class="col-6 lg:col-6" style="display: flex; justify-content: flex-end">
              <PrimeButton
                id="cancelbtn"
                name="Cancel"
                icon="pi pi-send"
                label="Send preview email"
                class="sendemail"
                @click="showPreviewPopup('cs')"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSaveCodeSubjectToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
                :placeholder="lmodel.ambassadorSaveCodeSubjectPlaceholder"
              >{{ lmodel.ambSaveCodeSubject }}</label>
              <Textarea
                v-model="vmodel1.ambSaveCodesubject"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSaveCodeSubjectPlaceholder"
                class="mt-1"
                id="customerSaveCodeSubject"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSaveCodeSubjectToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ staticData.prev_text }}</label>
              <InputText
                v-model="vmodel1.ambSaveCodesubhead"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSaveCodeSubheadPlaceholder"
                class="mt-1"
                id="customerSaveCodeSubhead"
              ></InputText>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSaveCodeSubjectToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ staticData.email_body }}</label>
              <Textarea
                v-model="vmodel1.ambSaveCodebody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSaveCodeBodyPlaceholder"
                class="mt-1 textareaBody"
                id="customerSaveCodeSubhead"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSaveCodeCTAButtonToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ lmodel.ambSaveCodeCTAButton }}</label>
              <InputText
                v-model="vmodel1.ambSaveCodectabutton"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSaveCodeCTAButtonPlaceholder"
                class="mt-1"
                id="customerSaveCodeSubhead"
              ></InputText>
            </div>
          </div>
        </div>
        <!-- Title End -->

        <!-- First Email Reminder -->
        <div>
          <div class="grid mt-3">
            <div class="col-6 lg:col-6">
              <span for="saveemail-copy" class="heading-text">
                {{
                lmodel.ambFirstReminderSectionTitle
                }}
              </span>
            </div>
            <div class="col-6 lg:col-6" style="display: flex; justify-content: flex-end">
              <PrimeButton
                id="cancelbtn"
                name="Cancel"
                icon="pi pi-send"
                label="Send preview email"
                class="sendemail"
                @click="showPreviewPopup('r')"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorFirstReminderSubjectToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ lmodel.ambFirstReminderSubject }}</label>
              <InputText
                v-model="vmodel1.ambFirstRemsubject"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorFirstReminderSubjectPlaceholder"
                class="mt-1"
                id="customerSaveCodeSubject"
              ></InputText>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSaveCodeSubjectToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ staticData.prev_text }}</label>
              <InputText
                v-model="vmodel1.ambFirstRemsubhead"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorFirstReminderSubheadPlaceholder"
                class="mt-1"
                id="customerSaveCodeSubhead"
              ></InputText>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorFirstReminderBodyToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ staticData.email_body }}</label>
              <Textarea
                v-model="vmodel1.ambFirstRembody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorFirstReminderBodyPlaceholder"
                class="mt-1 textareaBody"
                id="customerSaveCodeSubhead"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorFirstReminderBodyToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ lmodel.ambFirstReminderCTAButton }}</label>
              <InputText
                v-model="vmodel1.ambFirstRemctabutton"
                type="text"
                autocomplete="off"
                :placeholder="
                  lmodel.ambassadorFirstReminderCTAButtonPlaceholder
                "
                class="mt-1"
                id="customerSaveCodeSubhead"
              ></InputText>
            </div>
          </div>
        </div>
        <!-- First Email Reminder End-->

        <!-- Final Email Reminder start -->
        <div>
          <div class="grid mt-3">
            <div class="col-6 lg:col-6">
              <span for="saveemail-copy" class="heading-text">
                {{
                lmodel.ambSecondReminderSectionTitle
                }}
              </span>
            </div>
            <div class="col-6 lg:col-6" style="display: flex; justify-content: flex-end">
              <PrimeButton
                id="cancelbtn"
                name="Cancel"
                icon="pi pi-send"
                label="Send preview email"
                class="sendemail"
                @click="showPreviewPopup('r')"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSecondReminderSubjectToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ lmodel.ambSecondReminderSubject }}</label>
              <InputText
                v-model="vmodel1.ambSecRemsubject"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSecondReminderSubjectPlaceholder"
                class="mt-1 align-middle"
                id="customerSaveCodeSubject"
              ></InputText>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSecondReminderSubheadToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ staticData.prev_text }}</label>
              <InputText
                v-model="vmodel1.ambSecRemsubhead"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSecondReminderSubheadPlaceholder"
                class="mt-1 align-middle"
                id="customerSaveCodeSubhead"
              ></InputText>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSecondReminderBodyToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ staticData.email_body }}</label>
              <Textarea
                v-model="vmodel1.ambSecRembody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.ambassadorSecondReminderBodyPlaceholder"
                class="mt-1 textareaBody"
                id="customerSaveCodeSubhead"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.ambassadorSecondReminderCTAButtonToolTip"
                for="ambassadorSaveCodeSubject-tooltip"
                class="control-label"
              >{{ lmodel.ambSecondReminderCTAButton }}</label>
              <InputText
                v-model="vmodel1.ambSecRemctabutton"
                type="text"
                autocomplete="off"
                :placeholder="
                  lmodel.ambassadorSecondReminderCTAButtonPlaceholder
                "
                class="mt-1 align-middle"
                id="customerSaveCodeSubhead"
              ></InputText>
            </div>
          </div>
        </div>
        <!-- Final Email Reminder End -->
        <div class="grid mt-1">
          <div
            class="col-12 lg:col-6"
            :class="{
              redeal_disabled: enableAmbMails == false,
            }"
          >
            <label
              v-tooltip="lmodel.ambRemindBeforeDaysToolTip"
              tooltipvalueFor="ambRemindBeforeDays-tooltip"
              labelclass="control-label"
            >{{ lmodel.ambRemindBeforeDays }}</label>
            <InputRequiredNumber
              :validation="valmodel.ambCustomerRemindBeforeDays"
              v-model="vmodel1.ambCustomerRemindBeforeDays"
              id="ambCustomerRemindBeforeDays"
              PropName="First Remind Before Days"
              :placeholder="lmodel.ambRemindBeforeDaysPlaceholder"
              MinValue="0"
              MaxValueProp="Relative to impression date"
              class="w-full"
            ></InputRequiredNumber>
          </div>
          <div
            class="col-12 lg:col-6"
            :class="{
              redeal_disabled: enableAmbMails == false,
            }"
          >
            <label
              v-tooltip="lmodel.ambSecondRemindBeforeDaysToolTip"
              tooltipvalueFor="ambSecondRemindBeforeDays-tooltip"
              labelclass="control-label"
            >{{ lmodel.ambSecondRemindBeforeDays }}</label>
            <InputRequiredNumber
              :validation="valmodel.ambCustomerSecondRemindBeforeDays"
              v-model="vmodel1.ambCustomerSecondRemindBeforeDays"
              id="ambCustomerSecondRemindBeforeDays"
              PropName="Second Remind Before Days"
              :placeholder="lmodel.ambSecondRemindBeforeDaysPlaceholder"
              MinValue="0"
              MaxValueProp="first reminder"
              class="w-full"
            ></InputRequiredNumber>
          </div>
          <div
            class="col-12 lg:col-6"
            :class="{
              redeal_disabled:
                ambEnableDealToCustomer == false ||
                (enableAmbReminder == false && ambEnableDealToCustomer == true),
            }"
          >
            <label
              v-tooltip="lmodel.ambCampaignDealyDaysToolTip"
              tooltipvalueFor="ambCampaignDealyDays-tooltip"
              labelclass="control-label"
            >{{ lmodel.ambCampaignDealyDays }}</label>
            <InputRequiredNumber
              :validation="valmodel.ambCustomerCampaignDealyDays"
              v-model="vmodel1.ambCustomerCampaignDealyDays"
              id="ambCustomerCampaignDealyDays"
              PropName="Code Delivery Delay Days"
              :placeholder="lmodel.ambCampaignDealyDaysPlaceholder"
              MinValue="0"
              :hasError="customerCampaignDealyDaysError != null"
              class="w-full"
            ></InputRequiredNumber>
          </div>
          <div
            class="col-12 lg:col-6"
            v-if="
              vmodel1.ambCustomerUseDynamicCodes == false &&
              vmodel1.ambEnableDealToCustomer == true
            "
          >
            <label
              v-tooltip="lmodel.ambEANBarCodeTextToolTip"
              tooltipvalueFor="ambEANBarCodeText-tooltip"
              labelclass="control-label"
            >{{ lmodel.ambEANBarCodeText }}</label>
            <InputText
              v-model="vmodel1.ambCustomerEANBarCodeText"
              id="ambCustomerEANBarCodeText"
              type="text"
              autocomplete="off"
              class="w-full"
              @change="handleBarcodeChange()"
            />
          </div>
          <div
            class="col-6 ambassador_barcode"
            style="overflow: auto"
            v-if="
              vmodel1.ambCustomerEANBarCodeText &&
              vmodel1.ambEnableDealToCustomer
            "
          >
            <VueBarcode
              v-if="!vmodel1.ambCustomerBarcodeImgFileName"
              id="ambCustomerBarcodeImgFileName"
              :value="vmodel1.ambCustomerEANBarCodeText"
              :options="{ displayValue: false }"
              tag="img"
            />

            <img
              v-if="vmodel1.ambCustomerBarcodeImgFileName"
              id="imgcustomerBarcodeImgFileName"
              :src="vmodel1.ambCustomerBarcodeImgFullPath"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Pop-up -->
    <div v-if="$route.name == 'ManageDealUpdateById'">
      <SendMailPreview
        :ShowPopup="showPopup"
        userType="amb"
        :campaignid="this.id"
        :mailType="this.mailType"
        @closepopup="closePopup"
      />
    </div>
    <Dialog
      position="top "
      v-model="ShowChangePopup"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '500px', height: '20vw' }"
      class="popup"
    >
      <h2 class="text-center">{{ staticData.static_code }}</h2>
      <div class="row mt-2">
        <div class="col-12 mt-4">
          <label class="mt-2">{{ staticData.code }}</label>
          <input
            v-model="staticCodeText"
            id="staticCode"
            class="w-full mt-2"
            PropName="Static Code Value"
            :placeholder="lmodel.ambEnterStaticCodePlaceholder"
          />
          <PrimeButton
            type="button"
            style="margin-top: 13px; margin-left: 398px"
            tabindex="-1"
            label="Apply"
            id="send-mail"
            formnovalidate
            @click="replaceStaticCode"
          ></PrimeButton>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import SendMailPreview from "@/views/ManageDealUpdate/sendMail.vue";
import moment from "moment";
import staticData from "@/staticdata/static.json";
import VueBarcode from "@chenfengyuan/vue-barcode";
import Dialog from "primevue/dialog";
export default {
  components: {
    Dialog,
    SendMailPreview,
    VueBarcode
  },
  props: {
    ambEnableDealToCustomer: {
      type: Boolean,
      default: null
    },
    enableAmbReminder: {
      type: Boolean,
      default: null
    },
    enableAmbMails: {
      type: Boolean,
      default: null
    },

    dealId: {
      type: String,
      default: null
    },
    tabId: {
      type: Number,
      default: 0
    },
    lmodel: {
      type: Object,
      default: null
    },
    dmodel: {
      type: Object,
      default: null
    },
    vmodel: {
      type: Object,
      default: null
    },
    valmodel: {
      type: Object,
      default: null
    },
    dealStatus: {
      type: Number,
      default: null
    },
    isRedealText: {
      type: Boolean,
      default: false
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false
    },
    modelstate: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      staticData: staticData.message,
      errorMessage: true,
      catchError: "",
      todayDt: moment(),
      separatorExp: /,| /,
      id: "663c88808f6354bc3029a093",
      ShowChangePopup: false,
      mailType: "",
      showPopup: false,
      staticCodeText: ""
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },

  mounted() {
    document.body.style.overflow = "hidden";
  },
  methods: {
    closePopup() {
      this.showPopup = false;
    },
    showPreviewPopup(mailType) {
      this.mailType = mailType;
      this.showPopup = true;
    },
    handleBarcodeChange() {
      if (
        this.vmodel1.ambCustomerEANBarCodeText !=
        this.vmodel1.ambCustomerEANBarCodeTextExisting
      ) {
        this.vmodel1.ambCustomerBarcodeImgFileName = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
//start
.align-middle {
  vertical-align: middle;
}
.page-layout {
  // margin-top: 180px;
  padding: 12px 0px 24px 0px;
}

//end
input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

:deep(.p-chips:not(.p-disabled).p-focus .p-chips-multiple-container) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  height: 40px !important;
  resize: none;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}

:deep(.card-header) {
  height: 53px;
  border-color: #eff2f7;
  background: #fff;
  font-size: 16px;
  font-weight: 500 !important;
  padding: 0.75rem 1.25rem;
  border-bottom: none;
}

:deep(.p-textarea) {
  height: 79px;
}

:deep(.textareaBody) {
  height: 79px !important;
  .p-inputtextarea {
    height: 79px !important;
  }
}

.scroll-enable {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}
</style>
